import { workspaceV1LogoutOptions } from '@antimatterhq/asl-api-ts-v1';
import { useQuery } from '@tanstack/react-query';
import { defaultOptions } from '@/utils/query';

export const useWorkspaceLogout = (workspace: string) => {
  return useQuery({
    ...workspaceV1LogoutOptions({
      ...defaultOptions(),
      path: {
        workspace,
      },
    }),
    retry: false,
    enabled: false,
  });
};
